import { cloneDeep, isEmpty } from 'lodash'

const emptyContract = ({
  name: 'contrat 1',
  hide_appel_de_fond: false,
  hide_withdrawal_form_section: false,
  hide_mandataries_data: false,
  home_page_section: {
    name: 'Contrat préliminaire de réservation',
    mentions: []
  },
  reservataire_section: {
    name: 'Contrat préliminaire de réservation',
    mentions: []
  },
  special_condition_section: {
    name: 'Conditions particulières',
    mentions: []
  },
  // fees_and_intermediary_commission: {
  //   pinel_content: 'Conformément au Décret n° 2019-1426 du 20 décembre 2019 pris pour l’application de l’article 199 novovicies du code général des impôts et relatif au plafonnement des frais et commissions des intermédiaires intervenant lors d’une acquisition de logement bénéficiant de la réduction d’impôt, le réservataire déclare pour le bien ci-dessus désigné : </br> Avoir l’intention de demander le bénéfice de la réduction d’impôt Pinel visée à l’article 199 novovicies du Code Général des Impôts pour le bien ci-dessus désigné. Dans le cas où le réservataire déclare demander le bénéfice de la Réduction d’impôt Pinel : Le réservataire est informé que les frais et commissions directs et indirects supportés par le Réservant aux intermédiaires et que la part HT de ces frais et commissions n’excède pas 10% HT du prix de revient (1) de ce logement. </br> (1) Le prix de revient s’entend selon la doctrine fiscale comme le prix d’acquisition majoré des frais afférents à l’acquisition : honoraires de notaire, commissions versées aux intermédiaires, TVA, droits d’enregistrement le cas échéant et taxe de publicité foncière.',
  //   content: 'Conformément au Décret n° 2019-1426 du 20 décembre 2019 pris pour l’application de l’article 199 novovicies du codegénéral des impôts et relatif au plafonnement des frais et commissions des intermédiaires intervenant lors d’une acquisition de logement bénéficiant de la réduction d’impôt, le réservataire déclare pour le bien ci-dessus désigné : </br> Ne pas avoir l’intention de demander le bénéfice de la réduction d’impôt Pinel visée à l’article 199 novovicies du Code Général des Impôts pour le bien ci-dessus désigné.'
  // },
  appel_de_fond_section: {
    name: 'Autorisation de déblocage des fonds',
    mentions: []
  },
  withdrawal_form_section: {
    name: 'Formulaire de rétractation',
    mentions: []
  },
  dematerialized_notification: {
    name: 'NOTIFICATION DEMATERIALISÉE',
    authorized_notification: 'Autorisation de notification par voie électronique :<br> Le RESERVATAIRE donne son accord pour que la notification DU PRESENT CONTRAT DE RESERVATION et du projet d’acte en l’état futur d’achèvement prévue à l’article R. 261-30 du Code de la construction et de l’habitation lui soit faite par lettre recommandée par courrier électronique <b>(Les recommandés électroniques, comme leur équivalent papier, sont acheminés anonymement par un tiers, en l’occurence AR24)</b>, et ce conformément aux dispositions de l’article 1369-8 du code civil à l’adresse suivante :<br> (une adresse par réservataire)<br> Réservataires :<br>',
    buyer_recognition: 'Le RESERVATAIRE reconnait et garantit qu\'il dispose de la maitrise exclusive du compte e-mail ci-dessus, tant pour son accès régulier et sa gestion que pour la confidentialité des identifiants qui lui permettent d\'y accéder. Il déclare disposer des moyens techniques afin d\'accéder aux courriers recommandés électroniques depuis un client email et un navigateur Web fiables et mis à jour. Il s\'engage à communiquer tout changement d\'adresse email, à ne pas filtrer les notifications, ainsi qu\'à avoir une boite email disposant de suffisamment d\'espace libre pour recevoir lesdites notifications. Il s\'engage à signaler immédiatement toute perte ou usage abusif de son compte e-mail. Jusqu\'à la réception d\'une telle notification, toute action effectuée par le soussigné au travers de son compte e-mail sera réputée effectuée par lui et relèvera de la responsabilité exclusive de celui-ci.'
  },
  adf_custom_section_activated: false,
  adf_custom_section: {
    name: 'Autorisation de déblocage des fonds',
    mentions: []
  },
  pages: []
})
export default {
  name: 'ContractMixin',
  data () {
    return {
      loading: true,
      contract: null,
      program: null,
      adv: null,
      contracts: null
    }
  },
  computed: {
    contractPk () {
      if ('id' in this.$route.params && this.$route.name !== 'ContractList') {
        return this.$route.params.id
      } else if (this.contract && 'pk' in this.contract && this.contract.pk) {
        return this.contract.pk
      } else {
        return null
      }
    },
    programPk () {
      if ('program_id' in this.$route.params) {
        return this.$route.params.program_id
      } else {
        return null
      }
    },
    advPk () {
      if ('adv_id' in this.$route.params) {
        return this.$route.params.adv_id
      } else {
        return null
      }
    },
    documents () {
      if (this.program && 'documents' in this.program && !isEmpty(this.program.documents)) {
        let result = []
        for (let document of this.program.documents) {
          if ('destination' in document && document.destination.includes('reservation')) {
            result.push(document)
          }
        }
        return result
      } else return []
    }
  },
  props: {
  },
  async created () {
    if (this.contractPk) {
      this.getContract(this.contractPk)
    } else {
      this.contract = cloneDeep(emptyContract)
    }
    if (this.programPk) {
      this.getProgram()
    } else {
      this.getContracts()
    }
  },
  methods: {
    async getProgram () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.PROGRAM, this.programPk)
        this.program = data
        this.contracts = data.contracts
        this.$emit('updateTitle', { title: this.program.name, id: this.program.pk })
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
    async getContracts () {
      this.loading = true
      try {
        let params = {
          sort: 'name:asc',
          per_page: 200
        }
        let { data } = await this.$api.axios.get('custom-contracts', params)
        this.contracts = data.items.filter(item => item.contract_type === 'promotion')
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
    async createContract () {
      this.submitLoading = true
      let payload = {
        contract: this.contract
      }
      if (this.programPk) {
        payload['program'] = this.programPk
      }
      if (this.advPk) {
        payload['reservation'] = this.advPk
      }
      let { data } = await this.$api.axios.post(`custom-contracts`, payload)
      this.contract = data
      this.$toasted.global.success('Contrat créé')
      this.submitLoading = false
      let params = {
        id: this.contract.pk
      }
      if (this.programPk) {
        params['program_id'] = this.programPk
      }
      this.$router.replace({ name: 'ContractEdit', params: params })
    },
    async updateContract () {
      this.submitLoading = true
      let payload = {
        contract: this.contract
      }
      if (this.programPk) {
        payload['program'] = this.programPk
      }
      if (this.advPk) {
        payload['reservation'] = this.advPk
      }
      let { data } = await this.$api.axios.patch(`custom-contracts/${this.contractPk}`, payload)
      this.contract = data
      this.$toasted.global.success('Contrat modifié')
      this.submitLoading = false
    },
    async getContract (id) {
      this.loading = true
      try {
        let { data } = await this.$api.axios.get(`custom-contracts/${id}`)
        this.contract = data
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
    async callPreview (contract) {
      let payload = {
        contract: contract || this.contract,
        program: this.programPk
      }
      console.log(payload)
      if (this.documents.length) {
        payload['annexes'] = this.documents
      }
      return this.$api.axios.post(`preview-contract`, payload)
    },
    async openPreview (contract = null) {
      this.submitLoading = true
      let request = await this.callPreview(contract)
      this.submitLoading = false
      let params = {
        link: request.data
      }
      this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_SAAS', params })
    },
    async loadPdfLink (contract) {
      this.submitLoading = true
      let request = await this.callPreview(contract)
      this.submitLoading = false
      let href = request.data
      let link = document.createElement('a')
      link.href = href
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
    },
    // async openPreview (document) {
    //   let params = {
    //     link: document
    //   }
    //   this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_SAAS', params })
    // },
    openModalContract (create) {
      let params = {
        source: [this.contract, create]
      }
      this.$store.commit('setModal', { mode: 'CONTRACT_MODAL', params })
    }
  }
}
